
import { Component, Vue } from 'vue-property-decorator'
import { AnswerType } from '@/models/api/common/StudyResultTypes.vue'

export type StudyResultData = {
  studentName: string
  answers: AnswerType[]
}

@Component
export default class StudyResultApis extends Vue {
  /**
   * 受験履歴取得
   */
  protected async getStudyResultData(acbtCode?: string): Promise<StudyResultData> {
    let data: StudyResultData = { studentName: '', answers: [] }
    await Vue.prototype.$http.httpWithToken
      .get('/v1/branch/study_results', { params: { acbtCode: acbtCode } })
      .then((res: any) => {
        data = res.data
      })
    return data
  }
}
